import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { useHistory } from "react-router";
import moment from "moment";
import { Image, Button, Modal } from "react-bootstrap";
import SuperAdminDeleteEvent from "../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminDeleteEvent";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import ViewEventDetailsOffline from "./ViewEventDetailsOffline";
import ActiveDeactiveEventsAndOffers from "../../reusableComponents/allPopupReusable/offerEventPopup/ActiveDeactiveEventsAndOffers";
import ViewEventDetailsOnline from "./ViewEventDetailsOnline";
import {
  vendor_update_events,
  get_events_details,
} from "../../../store/actions/vendorOffersAndEventsAction";
import { SET_ONLINE_EVENT_DETAILS_VENDOR } from "../../../store/types";
import ReadMoreReact from "read-more-react";
import Switch from "react-switch";
import Alert from "react-s-alert";
import isEmpty from "../../../store/validation/is-Empty";
import { PopupActionButton } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

export const EventManagementTableBody = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });

  const [openModal, setOpenModal] = useState(false);
  const [actionBy, setActionBy] = useState("");
  const openClosedModal = () => setOpenModal(!openModal);

  const editOfflineEvent = (data) => (e) => {
    history.push({
      pathname: `/event/edit-offline-event`,
      state: { editData: data },
    });
  };

  const editOnlineEvent = (data) => (e) => {
    history.push({
      pathname: `/event/edit-online-event`,
      state: { editData: data },
    });
  };

  const viewOfflineEventAction = (id) => {
    history.push({
      pathname: `/offline-events-details/${id}`,
      state: { offlineEventInformation: id },
    });
  };

  const viewOnlineEventAction = (data) => {
    history.push({
      pathname: `/online-event-details/${data._id}`,
      state: { onlineEventInformation: data },
    });
    dispatch({
      type: SET_ONLINE_EVENT_DETAILS_VENDOR,
      payload: data,
    });
  };

  const token = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth?.user?.accessToken : "";
  });

  const onClickBookingClosed = (e, data, actionBy) => {
    setOpenModal(true);
    setActionBy(actionBy);
  };

  const deleteOfferEventClick = (e, data, actionBy) => {
    const eventId = data._id;
    let formData = {};
    if (actionBy === "RSVP") {
      formData.rsvp_booking_closed =
        data?.rsvp_booking_closed === true ? false : true;
    } else {
      formData.tb_booking_closed =
        data.tb_booking_closed === true ? false : true;
    }
    dispatch(
      vendor_update_events(formData, eventId, token, (e) =>
        onSuccessRsvp(e, actionBy)
      )
    );
  };

  const onSuccessRsvp = (e, data) => {
    console.log("Data ==>", data);
    Alert.success(`<h4>${data} Status updated successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    dispatch(get_events_details(token));
  };

  return (
    <>
      <tbody>
        <tr className="super_admin_all_users_table_body">
          <td colSpan="7" className="p-0 w-100">
            <table className="w-100 HideShowTable enMinWidth900">
              <tbody>
                <tr className="cursor" onClick={showTr}>
                  <td style={{ width: "25%" }}>
                    <div className="d-flex align-items-center">
                      <div
                        className="text-center d-flex flex-column align-items-center"
                        style={{ width: "20%" }}
                      >
                        <SimpleReactLightbox>
                          <SRLWrapper options={options}>
                            <Image
                              src={
                                props.data.photo_thumbnails &&
                                props.data.photo_thumbnails.length
                                  ? props.data.photo_thumbnails[0]
                                  : props.data.photos[0]
                              }
                              alt="View"
                              title="View"
                              fluid
                            />
                          </SRLWrapper>
                        </SimpleReactLightbox>
                        {props.data.isOnline ? (
                          <div className="enSuccessLBL mt-2">Online</div>
                        ) : (
                          <div className="enPendingLBL mt-2">Offline</div>
                        )}
                      </div>
                      <div className="pl-3">
                        <div className="f14-500">{props?.data?.name}</div>
                        <div
                          className="f11-500 opacity5 my-1"
                          style={{ wordBreak: "break-word" }}
                        >
                          #{props?.data?.event_id}
                        </div>
                        <div
                          id="read-more-text"
                          className="f10-500 opacity5 text-break"
                        >
                          <ReadMoreReact
                            text={props.data && props?.data?.description}
                            min={25}
                            ideal={50}
                            max={props.data && props.data.description.length}
                            readMoreText={"Read More"}
                          />
                        </div>
                      </div>
                    </div>
                  </td>

                  <td style={{ width: "15%" }}>
                    <div className="f12-500">
                      {moment(props.data.start_date).format("Do MMM YYYY")}
                    </div>
                    <div className="f12-500 text-red">
                      {moment(props.data.end_date).format("Do MMM YYYY")}
                    </div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="f12-400">
                      <div className="f12-400">
                        {moment(props.data.start_date).format("hh:mm A")}
                      </div>
                      <div className="f12-400 pl-4 py-1">to</div>
                      <div className="f12-400">
                        {moment(props.data.end_date).format("hh:mm A")}
                      </div>
                    </div>
                  </td>
                  <td
                    style={{ width: "12%" }}
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                    }}
                  >
                    <ActiveDeactiveEventsAndOffers
                      diameter={24}
                      height={15}
                      width={41}
                      activeProps={props.data}
                      displayActive={true}
                      actionButton="events"
                    />
                  </td>
                  <td
                    style={{ width: "13%" }}
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                    }}
                  >
                    <ActiveDeactiveEventsAndOffers
                      diameter={24}
                      height={15}
                      width={41}
                      activeProps={props.data}
                      displayPrimary={true}
                      actionButton="events"
                    />
                  </td>
                  <td
                    style={{ width: "20%" }}
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                    }}
                  >
                    {props.data.isOnline ? (
                      <button
                        onClick={() => viewOnlineEventAction(props.data)}
                        className="enViewDashboard btn btn-outline-danger"
                      >
                        <Image
                          src={require("../../../assets/images/ActionImages/image/onboarding.svg")}
                          alt="View"
                          title="View"
                          fluid
                          className="mr-2"
                        />
                        <div className="f12-500">View Dashboard</div>
                      </button>
                    ) : (
                      <button
                        onClick={() => viewOfflineEventAction(props.data._id)}
                        className="enViewDashboard btn btn-outline-danger"
                      >
                        <Image
                          src={require("../../../assets/images/ActionImages/image/onboarding.svg")}
                          alt="View"
                          title="View"
                          fluid
                          className="mr-2"
                        />
                        <div className="f12-500">View Dashboard</div>
                      </button>
                    )}
                  </td>
                </tr>
                {TrDetail.TrDetail && (
                  <tr className="border-top">
                    <td style={{ width: "20%" }}>
                      <div className="f12-500 text-red mb-3">More Actions</div>
                      <div className="d-flex align-items-center">
                        <SuperAdminDeleteEvent
                          actionBy={"vendor"}
                          eventId={props.data._id}
                        />
                        {props.data && props.data.isOnline ? (
                          <ViewEventDetailsOnline vendorEvent={props.data} />
                        ) : (
                          <ViewEventDetailsOffline vendorEvent={props.data} />
                        )}
                        {/* <NavLink
                        to="/event/edit-online-event"
                        className="enIconBtn mr-3"
                      >
                        <Image
                          src={require("../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </NavLink> */}
                        <div
                          className="enIconBtn mr-3"
                          onClick={
                            props.data && props.data.isOnline
                              ? editOnlineEvent(props.data)
                              : editOfflineEvent(props.data)
                          }
                        >
                          <Image
                            src={require("../../../assets/images/UserManagement/pencil.svg")}
                            alt="Edit"
                            title="Edit"
                            fluid
                          />
                        </div>
                      </div>
                    </td>

                    {/* If Online event venue will not be there */}
                    {props.data.venue_address === "" ? null : (
                      <td style={{ width: "15%" }}>
                        <div className="f12-500 mb-3">Venue</div>
                        <div className="f12-400 ">
                          {props.data.venue_address}
                        </div>
                      </td>
                    )}
                    {props.data && props.data.isOnline ? (
                      <></>
                    ) : (
                      <td style={{ width: "15%" }}>
                        <div className="f12-500 mb-3">RSVP</div>
                        <div className="d-flex align-items-center py-4">
                          <div
                            className={`${
                              props.data?.rsvp_booking_closed === false
                                ? "f11-400 mr-2"
                                : "f11-500 mr-2"
                            }`}
                          >
                            No
                          </div>
                          <Switch
                            onChange={(e) =>
                              onClickBookingClosed(e, props.data, "RSVP")
                            }
                            // disabled={true}
                            checked={
                              props.data?.rsvp_booking_closed ? false : true
                            }
                            offColor="#E0E0E0"
                            onColor="#E0E0E0"
                            offHandleColor="#212121"
                            onHandleColor="#59F832"
                            handleDiameter={24}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={15}
                            width={41}
                            boxShadow="-2px 0px 5px #0000003B"
                            activeBoxShadow="-2px 0px 5px #0000003B"
                            id="material-switch"
                          />
                          <div
                            className={`${
                              props.data?.rsvp_booking_closed === false
                                ? "f11-500 ml-2"
                                : "f11-400 ml-2"
                            }`}
                          >
                            Yes
                          </div>
                        </div>
                      </td>
                    )}
                    {props.data && props.data.isOnline ? (
                      <></>
                    ) : (
                      <td style={{ width: "15%" }}>
                        <div className="f12-500 mb-3">Ticket Booking</div>
                        <div className="d-flex align-items-center py-4">
                          <div
                            className={`${
                              props.data?.tb_booking_closed === false
                                ? "f11-400 mr-2"
                                : "f11-500 mr-2"
                            }`}
                          >
                            No
                          </div>
                          <Switch
                            onChange={(e) =>
                              onClickBookingClosed(
                                e,
                                props.data,
                                "Ticket Booking"
                              )
                            }
                            // disabled={true}
                            checked={
                              props.data?.tb_booking_closed ? false : true
                            }
                            offColor="#E0E0E0"
                            onColor="#E0E0E0"
                            offHandleColor="#212121"
                            onHandleColor="#59F832"
                            handleDiameter={24}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={15}
                            width={41}
                            boxShadow="-2px 0px 5px #0000003B"
                            activeBoxShadow="-2px 0px 5px #0000003B"
                            id="material-switch"
                          />
                          <div
                            className={`${
                              props.data?.tb_booking_closed === false
                                ? "f11-500 ml-2"
                                : "f11-400 ml-2"
                            }`}
                          >
                            Yes
                          </div>
                        </div>
                      </td>
                    )}
                    {props.data.eventPassword === undefined ? null : (
                      <td style={{ width: "15%" }}>
                        <div className="f12-500 mb-3">Event Code</div>
                        <div className="f12-400 enEllips">
                          {props.data.eventPassword}
                        </div>
                      </td>
                    )}
                    {!props?.data?.isOnline && (
                      <>
                        <td style={{ width: "15%" }}>
                          <div className="f12-500 mb-3">View Count</div>
                          <div className="f12-400">{props.data.eventViews}</div>
                        </td>

                        <td style={{ width: "10%" }}>
                          <div className="f12-500 mb-3">Used Count</div>
                          <div className="f12-400">
                            {props?.data?.leftOverTB
                              ? (props?.data?.total_quantity_TB || 0) +
                                (props?.data?.buffer_TB_guest || 0) -
                                props?.data?.leftOverTB
                              : (props?.data?.maxGuest_RSVP || 0) +
                                (props?.data?.buffer_RSVP_guest || 0) -
                                props?.data?.leftOverRSVP}
                          </div>
                        </td>
                        <td style={{ width: "10%" }}>
                          <div className="f12-500 mb-3">Left</div>
                          <div className="f12-400 enEllips">
                            {props?.data?.leftOverTB ||
                              props?.data?.leftOverRSVP}
                          </div>
                        </td>
                      </>
                    )}
                  </tr>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
      <Modal
        show={openModal}
        onHide={openClosedModal}
        backdrop={"static"}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="border-0" closeButton>
          <Modal.Title>
            <h4 className="f22-500">{actionBy}</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 className="f14-500">{`Are you sure you want to changed ${
            actionBy === "RSVP" ? "RSVP" : "Ticket Booking"
          } status`}</h4>
        </Modal.Body>
        <div className="bottom-button d-flex align-items-center justify-content-between px-4 py-4">
          <PopupActionButton
            buttonText="No"
            buttonType="button"
            buttonClass="bigbuttongray"
            onClick={openClosedModal}
          />
          <PopupActionButton
            buttonText="Yes"
            buttonType="button"
            buttonClass="bigbuttonred"
            onClick={(e) => deleteOfferEventClick(e, props?.data, actionBy)}
          />
        </div>
      </Modal>
    </>
  );
};
